import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const category: AdminBlockTypeAttribute = {
  label: 'Show category',
  key: 'category',
  inputType: AdminBlockAttributeInputType.CHECKBOX,
};

export default category;
